import "./app.less";
import "./index.d";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
import { GlobalDataProvider } from './stores/provider';
import { pageSpy } from "./utils";
const router = createBrowserRouter(routes);
function App() {
  useEffect(() => {
    pageSpy();
  }, []);

  return (
    <GlobalDataProvider>
      <RouterProvider router={router} />
    </GlobalDataProvider>
  );
}

export default App;
